import api from '@http/api';
import { FormatDate } from '@src/utils/formats';


export interface ILista {
   id: number;
  descricao: string;
  nomeCompleto: string;
  dataCadastro: string;
  dataExtracao: string;
  dataIntencaoMissa: string;
  dataIntencaoInicio: string;
  dataIntencaoFim: string;
  statusExtracao: number;
  perfilId: number;
  perfil: string;
  cidadeId: number;
  cidade: {
      id: number;
      estado: string;
      usuarioCadastro:string;
      descricao: string;
      dataCadastro: string;
      entidade: string;
  },
  estadoId: string;
  estado: {
      id: string;
      usuarioCadastro: string;
      descricao: string;
      sigla: string;
      dataCadastro: string;
      entidade: string;
      cidades: string;
      contatosOfflines: string;
  },
  usuarioCadastroId: string;
  usuarioCadastro: string;
  usuarioExtracaoId: string;
  usuarioExtracao: string;
  horarioDiasSemanaId: string;
  horarioDiasSemana: {
      id: string;
      horario: string;
      diaSemana: string;
      dataAlteracao: string;
      dataCadastro: string;
      statusAtivo: string;
      usuarioAlteracao: string;
      usuarioCadastro: string;
  },
  tipoSolicitacaoId: string;
  tipoSolicitacao: {
      id: string;
      descricao: string;
      formaContribuicao: string;
  },
  tipoIntencaoMissaId: string;
  tipoIntencaoMissa: {
    id: string;
    descricao: string;
    dataCadastro: string;
    statusAtivo: string;
    usuarioAlteracao: string;
    usuarioCadastro: string;
  },
}


export interface ILista2 {
  intencoes_missa: [
    {
  id: number;
 descricao: string;
 nomeCompleto: string;
 dataCadastro: string;
 dataExtracao: string;
 dataIntencaoMissa: string;
 dataIntencaoInicio: string;
 dataIntencaoFim: string;
 statusExtracao: number;
 perfilId: number;
 perfil: string;
 cidadeId: number;
 cidade: {
     id: number;
     estado: string;
     usuarioCadastro:string;
     descricao: string;
     dataCadastro: string;
     entidade: string;
 },
 estadoId: string;
 estado: {
     id: string;
     usuarioCadastro: string;
     descricao: string;
     sigla: string;
     dataCadastro: string;
     entidade: string;
     cidades: string;
     contatosOfflines: string;
 },
 usuarioCadastroId: string;
 usuarioCadastro: string;
 usuarioExtracaoId: string;
 usuarioExtracao: string;
 horarioDiasSemanaId: string;
 horarioDiasSemana: {
     id: string;
     horario: string;
     diaSemana: string;
     dataAlteracao: string;
     dataCadastro: string;
     statusAtivo: string;
     usuarioAlteracao: string;
     usuarioCadastro: string;
 },
 tipoSolicitacaoId: string;
 tipoSolicitacao: {
     id: string;
     descricao: string;
     formaContribuicao: string;
 },
 tipoIntencaoMissaId: string;
 tipoIntencaoMissa: {
  id: string;
  descricao: string;
  dataCadastro: string;
  statusAtivo: string;
  usuarioAlteracao: string;
  usuarioCadastro: string;
},
    }]
}

export interface IHorarioDiaSemana {
  id: number;
  horario: string;
}

class Services {
  public async GetListaAllIntencoesMissa(idTipoSolicitacao: string) {
    return await api
      .get<ILista[]>(`/api/IntencaoMissa/GetAllIntencaoMissa?idTipoSolicitacao=${idTipoSolicitacao}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async GetListaAllIntencoesMissaFiltros(idTipoSolicitacao: string, diaSelect: string, horarioSelect: string) {
    return await api
      .get<ILista[]>(`/api/IntencaoMissa/GetAllIntencaoMissa?idTipoSolicitacao=${idTipoSolicitacao}&dataIntencao=${diaSelect}&horario=${horarioSelect}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }


  public async GetHorarioDiaSemana(DiaSemana: string) {
    return await api
      .get<IHorarioDiaSemana[]>(
        `api/HorarioDiasSemana/GetAllHorariosByDiaSemana?DiaSemana=${DiaSemana}`,
      )
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async gerarListaIntecoesMissa(data: ILista2) {
    return await api
      .post('/api/IntencaoMissa/GerarLista', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }


}

export default Services;
